import { EconomicOperatorsAssignedToArticle, GPSRArticleData, GPSRLinkCategory, GPSRLinkDefinition } from "@medapro-types/common/compliance/gpsr";
import { GPSRLinkCategoryType } from "@medapro-types/common/compliance/gpsr-enum";
import _ from "lodash";
import api from "./api";
import endpoints from "./endpoints";

export default {
  getEconomicOperatorsAssignedToArticle: async function (articleId: string): Promise<EconomicOperatorsAssignedToArticle> {
    const response = await api.get(endpoints.gpsr.getEconomicOperatorsAssignedToArticle, {
      params: {
        articleId: articleId
      }
    });
    return response.data;
  },
  getResolvedArticleLinkData: async function (articleId: string, languageCodes: string[]): Promise<GPSRArticleData> {
    const languages = _.join(languageCodes, ",");
    const response = await api.get(endpoints.gpsr.getResolvedArticleLinkData, {
      params: {
        articleId: articleId,
        languages: languages
      }
    });
    return response.data;
  },
  assignEconomicOperatorsToArticle: async function (assignments: EconomicOperatorsAssignedToArticle) {
    const response = await api.post(endpoints.gpsr.assignEconomicOperatorsToArticle, assignments);
    return response.data;
  },
  getLinkDefinitions: async function (languageCodes: string[]): Promise<GPSRLinkDefinition[]> {
    const languages = _.join(languageCodes, ",");
    const response = await api.get(endpoints.gpsr.getLinkDefinitions, {
      params: {
        languages: languages
      }
    });
    return response.data;
  },
  getPossibleLinkDefinitions: async function (category: GPSRLinkCategoryType, languageCodes: string[]): Promise<GPSRLinkCategory> {
    const languages = _.join(languageCodes, ",");
    const response = await api.get(endpoints.gpsr.getPossibleLinkDefinitions, {
      params: {
        category: category,
        languages: languages
      }
    });
    return response.data;
  },
  saveLinkDefinitions: async function (linkDefinitions: GPSRLinkDefinition[]): Promise<void> {
    const response = await api.post(endpoints.gpsr.saveLinkDefinitions, linkDefinitions);
    return response.data;
  },
  deleteLinkDefinitions: async function (linkDefinitionsId: string[]): Promise<void> {
    const response = await api.post(endpoints.gpsr.deleteLinkDefinitions, linkDefinitionsId);
    return response.data;
  }
};
